import { type FunctionComponent } from "react";

import { AbstractField, type AbstractFieldProps } from "./AbstractField";

export interface TextFieldProps extends Omit<
  AbstractFieldProps,
  "type" | "render" | "children"
> {
  type?: "text" | "email" | "tel";
}

export const TextField: FunctionComponent<TextFieldProps> = ({
  type = "text",
  ...fieldProps
}) => <AbstractField type={type} {...fieldProps} />;
